import { render, staticRenderFns } from "./DigitalSolutionList.vue?vue&type=template&id=70a9198a&scoped=true"
import script from "./DigitalSolutionList.vue?vue&type=script&lang=js"
export * from "./DigitalSolutionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9198a",
  null
  
)

export default component.exports